import React from "react";

const FooterLayoutComponent = props => (
    <div className="footer">
        <div className="wrapper">
            <ul className="sns">
                <li>
                    <a className="home" href="http://www.tcedenim.com/" target="_blank">
                        <i></i>
                    </a>
                </li>
                <li>
                    <a className="facebook" href="https://www.facebook.com/TCEdenimstory/" target="_blank">
                        <i></i>
                    </a>
                </li>
                <li>
                    <a className="youtube" href="https://www.youtube.com/channel/UCXpRK4O2lJ9XaG9c-uQccPg"
                        target="_blank">
                        <i></i>
                    </a>
                </li>
            </ul>
            <div className="etc">
                {/* <ul className="lang">
                    <li className="en">
                        <a className="on" href="#">ENGLISH</a>
                    </li>
                    <li className="ko">
                        <a className="" href="#">KOREAN</a>
                    </li>
                </ul> */}
                <div className="copyright">
                    Copyright &copy;TCE. All rights reserved.
                            </div>
            </div>
        </div>
    </div>
)

export default FooterLayoutComponent;